import React from "react";
import { Link } from "react-router-dom";
import { displayDate } from "src/utils/dateHandler.util";
import { PopulatedRewardExchange } from "../karma-exchanges.service";
import {
  defaultExchangeStatus,
  getExchangeProviderName,
  getStatusPresentation,
  isTremendousPendingApproval,
} from "../utils/karma-exchange-ui";

interface Props {
  exchanges: PopulatedRewardExchange[];
}

const KarmaExchangesTable: React.FC<Props> = ({ exchanges }) => {
  return (
    <div className="mb-6 overflow-x-auto rounded-2xl border border-gray-200 bg-white shadow-sm">
      <table className="min-w-full divide-y divide-gray-200 text-sm text-slate-700">
        <thead className="bg-slate-50 text-slate-600">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Exchange ID</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Reward Name</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Username</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Amount</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Created</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Provider</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Status</th>
            <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">Action</th>
          </tr>
        </thead>

        <tbody>
          {exchanges?.length === 0 && (
            <tr>
              <td colSpan={8} className="px-4 py-8 text-center text-sm text-slate-500">
                No karma exchanges found
              </td>
            </tr>
          )}

          {exchanges?.map((req) => {
            const providerName = getExchangeProviderName(req);
            const currentStatus = req.status || defaultExchangeStatus;
            const isPendingApproval = isTremendousPendingApproval(req);
            const statusPresentation = getStatusPresentation(currentStatus, {
              isTremendousPendingApproval: isPendingApproval,
            });

            return (
              <tr
                key={req.id}
                className={`border-t border-gray-200 transition-colors hover:bg-slate-50 ${isPendingApproval ? "bg-amber-50/40" : "bg-white"
                  }`}
              >
                <td className="px-4 py-3 align-middle">
                  <span className="font-mono text-xs text-slate-700">{req.id}</span>
                </td>
                <td className="px-4 py-3 align-middle font-medium text-slate-800">{req.reward?.name || "—"}</td>
                <td className="px-4 py-3 align-middle">
                  {req.user ? (
                    <Link to={`/users/${req.userId}`} className="no-underline text-slate-700 hover:text-blue-600">
                      {req.user.name}
                    </Link>
                  ) : (
                    "—"
                  )}
                </td>
                <td className="px-4 py-3 align-middle">{req.amount} Karma</td>
                <td className="px-4 py-3 align-middle">{req.createdAt ? displayDate(req.createdAt) : "—"}</td>
                <td className="px-4 py-3 align-middle">{providerName}</td>
                <td className="px-4 py-3 align-middle">
                  <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${statusPresentation.badgeClasses}`}>
                    {statusPresentation.label}
                  </span>
                </td>
                <td className="px-4 py-3 text-right align-middle">
                  <Link
                    to={`/karma-exchanges/${req.id}`}
                    className="inline-flex items-center rounded-md border border-slate-200 px-3 py-1.5 text-sm font-medium text-slate-700 no-underline transition-colors hover:bg-slate-100"
                  >
                    View Details
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default KarmaExchangesTable;
